/**
 * Swagger Interface
 * 数据交换格式: JSON
 *
 * OpenAPI spec version: v2.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import ajax, { AjaxPromise, ExtraFetchParams } from '@ajax';
import * as models from '../model/models';

/* tslint:disable:no-unused-variable member-ordering object-literal-shorthand */

/**
 * @description shopCancelOrderOrderIdUsingPut参数
 * @property `orderId` 订单Id
 */
export interface ParamsshopCancelOrderOrderIdUsingPut {
  // pathParams
  /**
   * 订单Id
   */
  orderId: string;
}
/**
 * @description shopChangeOrderOrderIdUsingPut参数
 * @property `orderId` 订单Id
 */
export interface ParamsshopChangeOrderOrderIdUsingPut {
  // pathParams
  /**
   * 订单Id
   */
  orderId: string;
}
/**
 * @description shopCoinRecordUsernameUsingGet参数
 * @property `username` username
 * @property `[endDate]` 结束日期yyyy-MM-dd
 * @property `[startDate]` 开始日期yyyy-MM-dd
 */
export interface ParamsshopCoinRecordUsernameUsingGet {
  // pathParams
  /**
   * username
   */
  username: string;
  // queryParams
  /**
   * 结束日期yyyy-MM-dd
   */
  endDate?: string;
  /**
   * 开始日期yyyy-MM-dd
   */
  startDate?: string;
}
/**
 * coinRewardVO
 */
export type ParamsBodyshopCoinRewardUsingPost = models.CoinRewardVO;
/**
 * @description shopConvertedProductIdUsingPost参数
 * @property `productId` 商品Id
 * @property `payNum` 购买数量
 */
export interface ParamsshopConvertedProductIdUsingPost {
  // pathParams
  /**
   * 商品Id
   */
  productId: string;
  // queryParams
  /**
   * 购买数量
   */
  payNum: number;
}
/**
 * @description shopGetIncentSimpleVOUsingPost参数
 * @property `[bodyCode]` 1-文章 2-提问 3-回答
 * @property `[bodyId]` Id
 */
export interface ParamsshopGetIncentSimpleVOUsingPost {
  // queryParams
  /**
   * 1-文章 2-提问 3-回答
   */
  bodyCode?: number;
  /**
   * Id
   */
  bodyId?: number;
}
/**
 * @description shopOrderInfoUsingGet参数
 * @property `[orderId]` 订单Id
 * @property `[orderType]` 订单类型 0-全部 1-预定中 2-订单取消 3-订单完成
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 * @property `[productId]` 商品Id
 * @property `[username]` 客户姓名
 */
export interface ParamsshopOrderInfoUsingGet {
  // queryParams
  /**
   * 订单Id
   */
  orderId?: string;
  /**
   * 订单类型 0-全部 1-预定中 2-订单取消 3-订单完成
   */
  orderType?: number;
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
  /**
   * 商品Id
   */
  productId?: string;
  /**
   * 客户姓名
   */
  username?: string;
}
/**
 * coinIncentivesVO
 */
export type ParamsBodyshopPostIncentivesUsingPost = models.CoinIncentivesVO;
/**
 * @description shopProductUpdateProductIdUsingPut参数
 * @property `productId` 商品Id
 * @property `isDeleted` 上/下架 0-商品上架 1-商品下架
 */
export interface ParamsshopProductUpdateProductIdUsingPut {
  // pathParams
  /**
   * 商品Id
   */
  productId: string;
  // queryParams
  /**
   * 上/下架 0-商品上架 1-商品下架
   */
  isDeleted: number;
}
/**
 * shopSaveVO
 */
export type ParamsBodyshopShopinfoAddUsingPost = models.ShopSaveVO;
/**
 * @description shopShopinfoProductIdUsingGet参数
 * @property `productId` 商品Id
 */
export interface ParamsshopShopinfoProductIdUsingGet {
  // pathParams
  /**
   * 商品Id
   */
  productId: string;
}
/**
 * shopUpdateVO
 */
export type ParamsBodyshopShopinfoUpdateUsingPut = models.ShopUpdateVO;
/**
 * @description shopShoplistUsingGet参数
 * @property `pageNum` 当前页码
 * @property `pageSize` 每页条数
 */
export interface ParamsshopShoplistUsingGet {
  // queryParams
  /**
   * 当前页码
   */
  pageNum: number;
  /**
   * 每页条数
   */
  pageSize: number;
}
export class ShopApi {
  protected $basePath = '/community/be'.replace(/\/$/, '');

  public constructor(basePath?: string) {
    if (basePath !== undefined) {
      this.$basePath = basePath.replace(/\/$/, '');
    }
  }

  /**
   * 
   * @summary 交易取消
   * @param params ParamsshopCancelOrderOrderIdUsingPut
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public shopCancelOrderOrderIdUsingPut = (
    params: ParamsshopCancelOrderOrderIdUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/shop/cancelOrder/{orderId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.orderId, 'orderId');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 商品订单核销
   * @param params ParamsshopChangeOrderOrderIdUsingPut
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public shopChangeOrderOrderIdUsingPut = (
    params: ParamsshopChangeOrderOrderIdUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/shop/changeOrder/{orderId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.orderId, 'orderId');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 金币初始化
   
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public shopCoinInitUsingGet = (opt?: ExtraFetchParams): AjaxPromise<models.CommonResult> => {
    const path = '/api/shop/coin/init';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 账户记录查询
   * @param params ParamsshopCoinRecordUsernameUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultListCoinRecordVO
   */
  public shopCoinRecordUsernameUsingGet = (
    params: ParamsshopCoinRecordUsernameUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultListCoinRecordVO> => {
    const path = '/api/shop/coinRecord/{username}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('endDate' in params) p.query.endDate = params.endDate;
    if ('startDate' in params) p.query.startDate = params.startDate;
    ajax.check(params.username, 'username');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 赞赏
   
   * @param data: ParamsBodyshopCoinRewardUsingPost// coinRewardVO
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public shopCoinRewardUsingPost = (
    data: ParamsBodyshopCoinRewardUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/shop/coinReward';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.coinRewardVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 购买商品
   * @param params ParamsshopConvertedProductIdUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public shopConvertedProductIdUsingPost = (
    params: ParamsshopConvertedProductIdUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/shop/converted/{productId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('payNum' in params) p.query.payNum = params.payNum;
    ajax.check(params.payNum, 'payNum');
    ajax.check(params.productId, 'productId');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查看悬赏信息
   * @param params ParamsshopGetIncentSimpleVOUsingPost
   
   * @param opt ajax config
   * @returns models.CommonResultIncentSimpleVO
   */
  public shopGetIncentSimpleVOUsingPost = (
    params: ParamsshopGetIncentSimpleVOUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultIncentSimpleVO> => {
    const path = '/api/shop/getIncentSimpleVO';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('bodyCode' in params) p.query.bodyCode = params.bodyCode;
    if ('bodyId' in params) p.query.bodyId = params.bodyId;
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 交易订单查询
   * @param params ParamsshopOrderInfoUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultOrderInfoVO
   */
  public shopOrderInfoUsingGet = (
    params: ParamsshopOrderInfoUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultOrderInfoVO> => {
    const path = '/api/shop/orderInfo';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('orderId' in params) p.query.orderId = params.orderId;
    if ('orderType' in params) p.query.orderType = params.orderType;
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    if ('productId' in params) p.query.productId = params.productId;
    if ('username' in params) p.query.username = params.username;
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查看个人帐户
   
   
   * @param opt ajax config
   * @returns models.CommonResultShoppingInfo
   */
  public shopPersonalAccountUsingGet = (
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultShoppingInfo> => {
    const path = '/api/shop/personalAccount';
    const url = this.$basePath + path;
    const p: any = {};
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 问题悬赏
   
   * @param data: ParamsBodyshopPostIncentivesUsingPost// coinIncentivesVO
   * @param opt ajax config
   * @returns models.CommonResultIncentSimpleVO
   */
  public shopPostIncentivesUsingPost = (
    data: ParamsBodyshopPostIncentivesUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultIncentSimpleVO> => {
    const path = '/api/shop/postIncentives';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.coinIncentivesVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 商品上/下架
   * @param params ParamsshopProductUpdateProductIdUsingPut
   
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public shopProductUpdateProductIdUsingPut = (
    params: ParamsshopProductUpdateProductIdUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/shop/productUpdate/{productId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    p.query = {};
    if ('isDeleted' in params) p.query.isDeleted = params.isDeleted;
    ajax.check(params.isDeleted, 'isDeleted');
    ajax.check(params.productId, 'productId');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 商品添加
   
   * @param data: ParamsBodyshopShopinfoAddUsingPost// shopSaveVO
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public shopShopinfoAddUsingPost = (
    data: ParamsBodyshopShopinfoAddUsingPost,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/shop/shopinfo/add';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.shopSaveVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'POST',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查看商品信息
   * @param params ParamsshopShopinfoProductIdUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultShoppingInfo
   */
  public shopShopinfoProductIdUsingGet = (
    params: ParamsshopShopinfoProductIdUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultShoppingInfo> => {
    const path = '/api/shop/shopinfo/{productId}';
    const url =
      this.$basePath +
      path.replace(/\{([^}]+)\}/g, (all, param) => (param in params ? params[param] : param));
    const p: any = {};
    ajax.check(params.productId, 'productId');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 商品信息变更
   
   * @param data: ParamsBodyshopShopinfoUpdateUsingPut// shopUpdateVO
   * @param opt ajax config
   * @returns models.CommonResult
   */
  public shopShopinfoUpdateUsingPut = (
    data: ParamsBodyshopShopinfoUpdateUsingPut,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResult> => {
    const path = '/api/shop/shopinfo/update';
    const url = this.$basePath + path;
    const p: any = {};
    p.data = data;
    ajax.check(data, 'body.shopUpdateVO');
    return ajax.ajax(
      {
        ...opt,
        method: 'PUT',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
  /**
   * 
   * @summary 查看商城列表查询
   * @param params ParamsshopShoplistUsingGet
   
   * @param opt ajax config
   * @returns models.CommonResultPageableResultShoppingInfo
   */
  public shopShoplistUsingGet = (
    params: ParamsshopShoplistUsingGet,
    opt?: ExtraFetchParams
  ): AjaxPromise<models.CommonResultPageableResultShoppingInfo> => {
    const path = '/api/shop/shoplist';
    const url = this.$basePath + path;
    const p: any = {};
    p.query = {};
    if ('pageNum' in params) p.query.pageNum = params.pageNum;
    ajax.check(params.pageNum, 'pageNum');
    if ('pageSize' in params) p.query.pageSize = params.pageSize;
    ajax.check(params.pageSize, 'pageSize');
    return ajax.ajax(
      {
        ...opt,
        method: 'GET',
        url,
        ...p
      },
      path,
      this.$basePath
    );
  };
}

export default new ShopApi();
